<template>
  <van-icon name="wap-nav" class="aigc-nav-btn" @click="onClick" />
</template>

<script>
export default {
  name: "AigcNavButton",
  inject: {
    openAigcMenu: { default: null },
  },
  methods: {
    onClick() {
      if (typeof this.openAigcMenu === "function") {
        this.openAigcMenu();
      }
    },
  },
};
</script>

<style scoped>
.aigc-nav-btn {
  font-size: 20px;
  color: #303133;
  padding: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/aigc/AigcNavButton.vue